import { render, staticRenderFns } from "./TalkAskOpinion.vue?vue&type=template&id=7b3f1afc&scoped=true&"
import script from "./TalkAskOpinion.vue?vue&type=script&lang=ts&"
export * from "./TalkAskOpinion.vue?vue&type=script&lang=ts&"
import style0 from "./TalkAskOpinion.vue?vue&type=style&index=0&id=7b3f1afc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3f1afc",
  null
  
)

export default component.exports